module.exports = __webpack_public_path__ + "static/media/netural.628fc0a8.svg";